import React from "react";
import {
  Box,
  Dialog,
  Divider,
  IconButton,
  LinearProgress,
  Slide,
  Stack,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import MinimizeIcon from "@mui/icons-material/Minimize";
import CloseIcon from "@mui/icons-material/Close";
import { Images } from "../../assets/common";
import {
  HMS,
  getStreamCount,
  isOwnerId,
  truncate,
} from "../../constants/function";
import { useDispatch, useSelector } from "react-redux";
import StreamPlayer from "./streamPlayer";
import Loader from "../Loader";
import LockIcon from "@mui/icons-material/Lock";
import notifier from "../Notifier";
import ApiService from "../../services/api-service";
import NoData from "../Nodata";
import { start } from "../../action/streamSong";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
function SongRow({ song, onPlay, onLoader, track, playing, index }) {
  const { t } = useTranslation("common");
  const [progress, setProgress] = React.useState(80);
  const [loader, setLoader] = React.useState(false);
  const fetchSong = async () => {
    let streamCount = getStreamCount();
    if (streamCount === "undefined" || streamCount <= 0) {
      notifier.warning(t("notifier.warning.toast1"));
      return;
    }
    if (song.isPlaying) return;
    if (track) {
      onPlay(track, true);
      return;
    }

    if (
      !isOwnerId(song?.uploader._id) &&
      song.private &&
      !song?.uploader?.isSubscribed
    ) {
      notifier.error(t("notifier.error.toast5"));
      return;
    }

    onLoader(true);
    // setLoader(true);
    try {
      // const response = await fetch(song?.fileId?.filePath);
      // setLoader(false);
      // onPlay(response);
      const response = await fetchWithProgress(song?.fileId?.filePath);

      const file = await response.blob();
      // setLoader(false);
      onPlay(file);
      // onLoader(false);
    } catch (error) {
      // setLoader(false);
      onLoader(false);
      return null;
    }
  };
  const fetchWithProgress = async (url) => {
    const response = await fetch(url);
    const reader = response.body.getReader();
    const stream = new ReadableStream({
      start(controller) {
        const pump = () =>
          reader.read().then(({ done, value }) => {
            if (done) {
              controller.close();
              return;
            }
            controller.enqueue(value);
            const loaded = value.length;
            const total = +response.headers.get("Content-Length");
            const percentComplete = (loaded / total) * 100;
            setProgress(percentComplete);
            console.log(`Downloaded ${percentComplete}%`);
            return pump();
          });
        return pump();
      },
    });

    return new Response(stream, response);
  };
  return (
    <Stack
      direction="column"
      sx={{
        position: "relative",
        paddingTop: "5px",
        background: !song?.isPlaying && song?.lastPlayed ? "#2a2a2a" : "none",
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        spacing={2}
        sx={{ padding: "0px 16px" }}
      >
        <Stack direction="row" alignItems="center" gap="10px">
          <Box
            sx={{ position: "relative" }}
            className="_song_row_music _cp"
            onClick={fetchSong}
          >
            <img
              className="avatar"
              src={song?.thumbnailImg?.filePath || Images.default_music}
              alt=""
            />

            <img className="__play_now _cp" src={Images.play} alt="play" />
          </Box>
          <Stack direction="column">
            <Typography title={song.title} className="fs-17">
              {truncate(song.title, 30)}
            </Typography>
            {/* <Stack direction="row" spacing={1} alignItems="center"> */}
              {song.private ? (
              <LockIcon
                sx={{
                  width: "14px",
                  height: "14px",
                  padding: "3px",
                  color: "#ffffff",
                  backgroundColor: "#4E4E4E",
                }}
                className="__small_icon"
              />
            ) : null}
            {/* <Typography title={song?.artist} className="fs-12 fade-text">
              {truncate(song?.artist, 30)}
            </Typography>
            </Stack> */}
          </Stack>
        </Stack>
        <Stack direction="row" alignItems="baseline" gap="10px">
          {playing === index ? (
            <img style={{ width: "14px" }} src={Images.listenYellow} alt="" />
          ) : null}
          <Typography className="fs-13">{HMS(song.duration)}</Typography>
        </Stack>
      </Stack>
      {/* {loader ? (
        <LinearProgress
          value={progress}
          variant="determinate"
          color="primary"
          sx={{ position: "absolute", top: 0, width: "100%", height: "2px" }}
        />
      ) : null} */}
    </Stack>
  );
}
export default function SongList({ handleClose, open, roomId, liveUsers }) {
  const dispatch = useDispatch();
  const { songs, index, track, vol } = useSelector((state) => state.streamSong);
  const { t } = useTranslation("common");
  const [loader, setLoader] = React.useState(false);
  React.useEffect(() => {
    const isPlaying = songs[index]?.isPlaying || false;
    if (isPlaying) {
      console.log("*******************");
      setLoader(false);
    }
  }, [index]);

  React.useEffect(() => {
    if (songs.length === 0 && index < 0) {
      getPlaylistDetail(roomId);
    }
  }, []);
  const getPlaylistDetail = async (roomId) => {
    try {
      setLoader(true);
      const response = await ApiService.PLAYLIST_DETAIL({
        _id: roomId,
        pageNo: 1,
        pageSize: 1,
      });
      if (response["result"]["music"].length > 0)
        dispatch(
          start({
            index: -1,
            songs: response["result"]["music"],
            pos: 0,
            track: null,
            timeStamp: null,
            vol: 100,
          })
        );
      setLoader(false);
    } catch (error) {
      setLoader(false);
    }
  };
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      PaperProps={{
        style: {
          background: "#1A1A1A",
          boxShadow: "none",
          color: "#ffffff",
          borderRadius: 16,
          width: "444px",
          //   height: "185px",
          top: "28px",
        },
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ padding: "10px 16px 0", height: "46px" }}
      >
        <Typography className="fs-16">{t("myMusic.songs")}</Typography>
        <Stack direction="row" alignItems="baseli">
          {/* <IconButton>
            <MinimizeIcon className="_cp _small_icons" color="default" />
          </IconButton> */}
          <IconButton onClick={() => handleClose(false)}>
            <CloseIcon className="_cp _small_icons" color="default" />
          </IconButton>
        </Stack>
      </Stack>
      <Divider color="#1E1E1E" sx={{ height: "2px" }} />
      <Stack
        direction="column"
        sx={{
          position: "relative",
          padding: "16px 0 70px 0",
          height: "calc(100vh - 208px)",
          overflow: "scroll",
        }}
      >
        {songs.length > 0 ? (
          songs.map((song, i) => (
            <SongRow
              key={i}
              song={song}
              track={index === i ? track : null}
              onPlay={(songData, restart) =>
                handleClose(
                  songData,
                  songs,
                  i,
                  index,
                  restart ? restart : false,
                  vol
                )
              }
              onLoader={(load) => setLoader(load)}
              playing={index}
              index={i}
            />
          ))
        ) : (
          <NoData lable={t("noData.message13")} />
        )}
      </Stack>
      <StreamPlayer
        liveUsers={liveUsers}
        handleFile={(song, songs, index, prevIndex, restart, volume, preSong) =>
          handleClose(song, songs, index, prevIndex, restart, volume, preSong)
        }
        roomId={roomId}
        onLoader={(load) => setLoader(load)}
      />
      {loader ? <Loader wait={true} _class="__loader_inside" /> : null}
    </Dialog>
  );
}
